import { connect } from "react-redux";
import React, { Component } from "react";
import { TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  Select,
  FormControl,
  MenuItem,
  Button
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    alignItems: "baseline",
    paddingBottom: theme.spacing(1)
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: 250
  },
  dialogPaper: {
    minHeight: "80vh",
    maxHeight: "80vh"
  },
  formsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  }
});

class ClientDialog extends Component {
  state = {};
  render() {
    const { classes, client } = this.props;
    return (
      <Dialog fullWidth={true} maxWidth="md" open={this.props.isDialogOpen}>
        <DialogTitle id="form-dialog-title">Dodaj klienta</DialogTitle>
        <DialogContent className={classes.formsContainer}>
          <h2>Klient</h2>
          <form className={classes.container} id="client">
            <TextField
              id="name"
              label="Imię i nazwisko / nazwa firmy"
              className={classes.textField}
              value={client.nazwa}
              name="nazwa"
              onChange={this.props.onClientChange}
              required={true}
              error={this.props.isError ? true : false}
              helperText={this.props.isError ? "Pole wymagane" : null}
            />
            <FormControl className={classes.textField}>
              <InputLabel>Rodzaj</InputLabel>
              <Select
                inputProps={{
                  name: "rodzaj"
                }}
                onChange={this.props.onClientChange}
                value={client.rodzaj}
              >
                <MenuItem value="Osoba prywatna">Osoba prywatna</MenuItem>
                <MenuItem value="Firma">Firma</MenuItem>
                <MenuItem value="Pracownik">Pracownik</MenuItem>
              </Select>
            </FormControl>

            <TextField
              onChange={this.props.onClientChange}
              name="ulica"
              id="address"
              label="Ulica i nr domu"
              className={classes.textField}
              value={client.ulica}
            />
            <TextField
              id="postcode"
              label="Kod Pocztowy"
              className={classes.textField}
              value={client.kod}
              name="kod"
              onChange={this.props.onClientChange}
            />
            <TextField
              id="city"
              label="Miejscowość "
              className={classes.textField}
              value={client.miasto}
              onChange={this.props.onClientChange}
              name="miasto"
            />
            <TextField
              id="pesel"
              label="Pesel/ / data urodzenia"
              className={classes.textField}
              value={client.pesel}
              onChange={this.props.onClientChange}
              name="pesel"
            />
            <TextField
              id="clientId"
              label="Seria i nr dowodu osobistego"
              className={classes.textField}
              name="dowod"
              value={client.dowod}
              onChange={this.props.onClientChange}
            />
            <TextField
              value={client.nip}
              id="nip"
              label="Nip"
              className={classes.textField}
              onChange={this.props.onClientChange}
              name="nip"
            />
            <TextField
              id="phone"
              label="Telefon"
              className={classes.textField}
              value={client.telefon}
              name="telefon"
              onChange={this.props.onClientChange}
            />
            <TextField
              id="email"
              label="email"
              className={classes.textField}
              value={client.email}
              onChange={this.props.onClientChange}
              name="email"
            />
            <TextField
              id="regon"
              label="regon"
              className={classes.textField}
              value={client.regon}
              name="regon"
              onChange={this.props.onClientChange}
            />
            <TextField
              value={client.limitkm}
              id="km-limit"
              type="number"
              label="Limit km"
              className={classes.textField}
              name="limitkm"
              onChange={this.props.onClientChange}
            />
          </form>

          <h2>Kierowca</h2>
          <form className={classes.container}>
            <TextField
              id="drivers-name"
              label="Imię i nazwisko"
              className={classes.textField}
              value={client.kierowca_imie}
              onChange={this.props.onClientChange}
              name="kierowca_imie"
            />
            <TextField
              id="address"
              label="Ulica i nr"
              className={classes.textField}
              value={client.kierowca_ulica}
              onChange={this.props.onClientChange}
              name="kierowca_ulica"
            />
            <TextField
              id="postcode"
              label="Kod pocztowy"
              className={classes.textField}
              value={client.kierowca_kod}
              onChange={this.props.onClientChange}
              name="kierowca_kod"
            />
            <TextField
              value={client.kierowca_miasto}
              id="city"
              label="Miasto"
              className={classes.textField}
              onChange={this.props.onClientChange}
              name="kierowca_miasto"
            />
            <TextField
              id="license-number"
              label="Nr prawa jazdy "
              className={classes.textField}
              value={client.prawo_jazdy}
              name="prawo_jazdy"
              onChange={this.props.onClientChange}
            />
            <TextField
              id="license-issue-date"
              label="Data wydania prawa jazdy"
              type="date"
              className={classes.textField}
              value={moment.unix(client.data_prawa_jazdy).format("YYYY-MM-DD")}
              name="data_prawa_jazdy"
              onChange={this.props.onClientChange}
            />
            <TextField
              id="issued-by"
              label="Organ wydający prawo jazdy"
              className={classes.textField}
              name="organ"
              value={client.organ}
              onChange={this.props.onClientChange}
            />
            <TextField
              id="pesel"
              label="Pesel lub data urodzenia"
              className={classes.textField}
              value={client.kierowca_pesel}
              name="kierowca_pesel"
              onChange={this.props.onClientChange}
            />
            <TextField
              id="phone"
              label="Telefon"
              className={classes.textField}
              value={client.kierowca_telefon}
              onChange={this.props.onClientChange}
              name="kierowca_telefon"
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onDialogSwitch}>Anuluj</Button>
          <Button
            onClick={() => {
              this.props.onClientSave(client, this.props.token);
            }}
            color="primary"
          >
            Zapisz
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  return { token: state.authReducer.token };
};

export default connect(mapStateToProps)(withStyles(styles)(ClientDialog));
